import styled from '@emotion/styled'

export default styled.div`
  padding-top: 1em;
`